import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { BalanceInformationNodeModel } from '../../models';
import { TypeUtils } from '../../../common/misc';
import { InstanceUtils } from '../../misc';
import { SignedShareTypeInput } from '../../node_inputs/BalanceInformationNodeInputs';
import './BalanceInformationHeader.less';

interface Props {
    node: BalanceInformationNodeModel;
}

const BalanceInformationHeader: React.FC<Props> = ({ node }) => {
    return (
        <div className="balance-information-header-container">
            <div className="left-container">
                <div className="header-item">
                    <span className="header-item-label">Currency:</span>
                    <span className="header-item-value">
                        {TypeUtils.isString(node.currencyInput?.value) ? node.currencyInput?.value : '–'}
                    </span>
                </div>

                <div className="header-item">
                    <span className="header-item-label">Net due:</span>
                    <span className="header-item-value">{node.netDueLabel}</span>
                </div>
            </div>

            <div className="right-container">
                {InstanceUtils.isInputWithSource(node.signedShareTypeInput) && (
                    <SignedShareTypeInput input={node.signedShareTypeInput} />
                )}
            </div>
        </div>
    );
};

export default observer(BalanceInformationHeader);
